import {
    CREATE_STYLE_MASTER_FAILURE,
    CREATE_STYLE_MASTER_REQUEST,
    CREATE_STYLE_MASTER_SUCCESS,
    CREATE_USER_FORM_STYLE_MASTER,
    DELETE_STYLE_MASTER_FAILURE,
    DELETE_STYLE_MASTER_REQUEST,
    DELETE_STYLE_MASTER_SUCCESS,
    FETCH_STYLE_MASTER_FAILURE,
    FETCH_STYLE_MASTER_REQUEST,
    FETCH_STYLE_MASTER_SUCCESS,
    FETCH_SINGLE_STYLE_MASTER_FAILURE,
    FETCH_SINGLE_STYLE_MASTER_REQUEST,
    FETCH_SINGLE_STYLE_MASTER_SUCCESS,
    STYLE_MASTER_USERFORM_RESET,
    UPDATE_STYLE_MASTER_FAILURE,
    UPDATE_STYLE_MASTER_REQUEST,
    UPDATE_STYLE_MASTER_SUCCESS,
    STYLE_MASTER_USERFORM_DROPDOWNLIST_RESET,
    NAVIGATE_STYLE_DETAILS,
    NAVIGATE_STYLE_MASTER,
    NAVIGATE_STYLE_PREPARATION,
    NAVIGATE_STYLE_MASTER_MAIN,
    FETCH_STYLE_MASTER_BY_ID_REQUEST,
    FETCH_STYLE_MASTER_BY_ID_SUCCESS,
    FETCH_STYLE_MASTER_BY_ID_FAILURE,
    FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_REQUEST,
    FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_SUCCESS,
    FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_FAILURE,
    CHECK_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
    CHECK_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
    CHECK_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,
    CREATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST,
    CREATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS,
    CREATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE,
    RESET_DIA_RESPONSE,
    CREATE_USER_FORM_COPY_STYLE_MASTER,
    COPY_STYLE_MASTER_USERFORM_RESET,
    CREATE_COPY_STYLE_MASTER_PART_REQUEST,
    CREATE_COPY_STYLE_MASTER_PART_SUCCESS,
    CREATE_COPY_STYLE_MASTER_PART_FAILURE,
    FETCH_MULTI_COPY_STYLE_MASTER_REQUEST,
    FETCH_MULTI_COPY_STYLE_MASTER_SUCCESS,
    FETCH_MULTI_COPY_STYLE_MASTER_FAILURE,
    FETCH_MULTI_COPY_STYLE_COLOR_MASTER_REQUEST,
    FETCH_MULTI_COPY_STYLE_COLOR_MASTER_SUCCESS,
    FETCH_MULTI_COPY_STYLE_COLOR_MASTER_FAILURE,
    STYLE_MASTER_UPDATE_APPROVALSTATUS_REQUEST,
    STYLE_MASTER_UPDATE_APPROVALSTATUS_SUCCESS,
    STYLE_MASTER_UPDATE_APPROVALSTATUS_FAILURE,
    COPY_STYLE_MASTER_ASSIGN_COLOR_REQUEST,
    COPY_STYLE_MASTER_ASSIGN_COLOR_SUCCESS,
    COPY_STYLE_MASTER_ASSIGN_COLOR_FAILURE,
    CREATE_COPY_STYLE_MASTER_REQUEST,
    CREATE_COPY_STYLE_MASTER_SUCCESS,
    CREATE_COPY_STYLE_MASTER_FAILURE,
    SET_COPY_MODAL_VAR,
    SEND_VERIFY_OTP_USERFORM,
    SEND_VERIFY_OTP_USERFORM_REQUEST,
    SEND_VERIFY_OTP_USERFORM_SUCCESS,
    SEND_VERIFY_OTP_USERFORM_FAILURE,
    FETCH_COPY_STYLE_MASTER_REQUEST,
    FETCH_COPY_STYLE_MASTER_SUCCESS,
    FETCH_COPY_STYLE_MASTER_FAILURE,
    DELETE_COPY_STYLE_MASTER_REQUEST,
    DELETE_COPY_STYLE_MASTER_SUCCESS,
    DELETE_COPY_STYLE_MASTER_FAILURE,
    UPDATE_COPY_STYLE_MASTER_REQUEST,
    UPDATE_COPY_STYLE_MASTER_SUCCESS,
    UPDATE_COPY_STYLE_MASTER_FAILURE,
    FETCH_COPY_STYLE_MASTER1_REQUEST,
    FETCH_COPY_STYLE_MASTER1_SUCCESS,
    FETCH_STYLE_MASTER_DELETE_BY_ID_REQUEST,
    FETCH_STYLE_MASTER_DELETE_BY_ID_SUCCESS,
    FETCH_STYLE_MASTER_DELETE_BY_ID_FAILURE,
    COPY_STYLE_MASTER_USERFORM_RESET2,
    FILE_UPLOAD_DATA_GET_LIST_SUCCESS,
    NAVIGATE_SIZE_MEASUREMENTS_DETAILS,
    SET_RADIO_BUTTON_DATA_COPY_STYLE,
    CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST,
    CREATE_COPY_STYLE_MASTER_NEW_OPTION_SUCCESS,
    CREATE_COPY_STYLE_MASTER_NEW_OPTION_FAILURE,
    RESET_UPLOAD_ID_GET,
    FETCH_COSTING_ACTIVE_ONLY_SUCCESS,
    FETCH_COSTING_ACTIVE_ONLY_REQUEST,
    FETCH_COSTING_ACTIVE_ONLY_FAILURE
} from './styleMaster.actionsType';

export const STYLE_MASTER = 'styleMaster';

let initialState = {
    loading: false,
    copyStyleLoading: false,
    styleMasterList: [],
    styleMasterByIdList: [],
    costingActiveList: [],
    sizeMeasurementList: [],
    multiCopyColorList: [],
    copyStyleColorList: [],
    deleteStyleMasterById: [],
    copyStyleMasterList: {},
    copyStyleMasterListAfterAdd: {},
    userform: {
        AccessoriesPO: true,
        YarnFabricPO: true,
        fldIsGarment: false
    },
    copyStyleForm: {
        InwardNO: [],
        fldFKColour: [],
        fldColour: [],
        idCopyMainStyle: true,
        isCopyAll: false,
        isBuyerCheck: false
    },
    selectedStyle: {},
    isStyleMaster: 'styleMasterMain',
    isDefaultValue: false,
    stylePreparationFlag: null,
    isStylePreparation: false,
    styleMasterId: '',
    styleMasterMainId: {},
    errorMessage: '',
    diaResponseStatus: '',
    copyModal: false,
    approvalstatus: [],
    verifyOTP: '',
    uploadId: '',
    renderGridBtn: 'Style Master',
    checkReadyStatus: false
};

export let styleMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload, flag } = action;
    switch (type) {
        case FETCH_STYLE_MASTER_REQUEST:
        case FETCH_COPY_STYLE_MASTER_REQUEST:
        case FETCH_STYLE_MASTER_DELETE_BY_ID_REQUEST:
        case FETCH_COPY_STYLE_MASTER1_REQUEST:
        case COPY_STYLE_MASTER_ASSIGN_COLOR_REQUEST:
        case SEND_VERIFY_OTP_USERFORM_REQUEST:
        case FETCH_MULTI_COPY_STYLE_MASTER_REQUEST:
        case FETCH_MULTI_COPY_STYLE_COLOR_MASTER_REQUEST:
        case CREATE_STYLE_MASTER_REQUEST:
        case CREATE_COPY_STYLE_MASTER_PART_REQUEST:
        case UPDATE_STYLE_MASTER_REQUEST:
        case UPDATE_COPY_STYLE_MASTER_REQUEST:
        case FETCH_SINGLE_STYLE_MASTER_REQUEST:
        case DELETE_STYLE_MASTER_REQUEST:
        case DELETE_COPY_STYLE_MASTER_REQUEST:
        case FETCH_STYLE_MASTER_BY_ID_REQUEST:
        case FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_REQUEST:
        case CHECK_STITCHING_MEASUREMENT_BY_STYLE_REQUEST:
        case CREATE_STITCHING_MEASUREMENT_BY_STYLE_REQUEST:
        case STYLE_MASTER_UPDATE_APPROVALSTATUS_REQUEST:
        case CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST:
        case FETCH_COSTING_ACTIVE_ONLY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_COPY_STYLE_MASTER_REQUEST:

            return {
                ...state,
                loading: false,
                copyStyleLoading: true
            };
        case CREATE_COPY_STYLE_MASTER_NEW_OPTION_REQUEST:
            return {
                ...state,
                loading: false,
                copyStyleLoading: true
            };
        case SET_COPY_MODAL_VAR:
            return {
                ...state,
                copyModal: payload
            };
        case FETCH_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterList: updatePayload
            };
        case FILE_UPLOAD_DATA_GET_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                uploadPreviewImg: updatePayload || []
            }
        case FETCH_STYLE_MASTER_DELETE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                deleteStyleMasterById: updatePayload
            };
        case FETCH_COPY_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                copyStyleMasterList: { ...state.copyStyleMasterList, ...updatePayload }
            };
        case FETCH_COPY_STYLE_MASTER1_SUCCESS:
            return {
                ...state,
                loading: false,
                copyStyleMasterListAfterAdd: updatePayload,
                copyStyleMasterList: { ...state.copyStyleMasterList, ...updatePayload }
            };
        case SEND_VERIFY_OTP_USERFORM_SUCCESS:
            return {
                ...state,
                loading: false,
                verifyOTP: updatePayload
            };
        case COPY_STYLE_MASTER_ASSIGN_COLOR_SUCCESS:
            return {
                ...state,
                loading: false,
                copyStyleForm: {
                    InwardNO: [],
                    fldFKColour: [],
                    fldColour: [],
                    idCopyMainStyle: state.copyStyleForm.idCopyMainStyle,
                    isCopyAll: false,
                    isBuyerCheck: false
                },
                copyStyleColorList: []
                // styleMasterList: updatePayload
            };
        case FETCH_MULTI_COPY_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                multiCopyColorList: updatePayload
            };
        case FETCH_MULTI_COPY_STYLE_COLOR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                copyStyleColorList: updatePayload
            };
        case FETCH_STYLE_MASTER_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterByIdList: updatePayload
            };
        case FETCH_COSTING_ACTIVE_ONLY_SUCCESS:
            return {
                ...state,
                loading: false,
                costingActiveList: updatePayload
            };
        case CHECK_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementList: updatePayload
            };
        case CREATE_STITCHING_MEASUREMENT_BY_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                diaResponseStatus: updatePayload
            };
        case FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_SUCCESS:
            return {
                ...state,
                loading: false,
                isDefaultValue: updatePayload
            };
        case CREATE_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedStyle: {},
                uploadId: updatePayload
            };
        case CREATE_COPY_STYLE_MASTER_PART_SUCCESS:
            return {
                ...state,
                loading: false,
                copyStyleForm: {
                    InwardNO: [],
                    fldFKColour: [],
                    fldColour: [],
                    idCopyMainStyle: state.copyStyleForm.idCopyMainStyle,
                    isCopyAll: false,
                    isBuyerCheck: false
                }
            };
        case CREATE_COPY_STYLE_MASTER_SUCCESS:

            return {
                ...state,
                loading: false,
                copyStyleLoading: false,
                copyStyleForm: {
                    InwardNO: [],
                    fldFKColour: [],
                    fldColour: [],
                    idCopyMainStyle: true,
                    isCopyAll: false,
                    isBuyerCheck: false
                },
                copyStyleMasterList: {},
                multiCopyColorList: [],
                copyStyleMasterListAfterAdd: {},
                copyStyleColorList: []
            };
        case CREATE_COPY_STYLE_MASTER_NEW_OPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                copyStyleLoading: false,
                copyStyleForm: {
                    InwardNO: [],
                    fldFKColour: [],
                    fldColour: [],
                    idCopyMainStyle: true,
                    isCopyAll: false,
                    isBuyerCheck: false
                },
                copyStyleMasterList: {},
                multiCopyColorList: [],
                copyStyleMasterListAfterAdd: {},
                copyStyleColorList: []
            };
        case UPDATE_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedStyle: {},
                uploadId: updatePayload
            };
        case RESET_UPLOAD_ID_GET:
            return {
                ...state,
                uploadId: ''
            }
        case UPDATE_COPY_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case STYLE_MASTER_UPDATE_APPROVALSTATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                approvalstatus: updatePayload
            };
        case FETCH_SINGLE_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload,
                    AccessoriesPO: updatePayload?.fldRequirementOption === "A" || updatePayload?.fldRequirementOption === 'B' || updatePayload?.fldRequirementOption === null ? true : false,
                    YarnFabricPO: updatePayload?.fldRequirementOption === "F" || updatePayload?.fldRequirementOption === 'B' || updatePayload?.fldRequirementOption === null ? true : false,
                    fldIsGarment: updatePayload?.fldRequirementOption === "R" || updatePayload?.fldRequirementOption === null ? true : false,
                    checkReadyStatus: updatePayload.fldIsGarment || false,
                    FldIsPartColourKG: updatePayload?.FldIsPartColourKG || false,
                    FldProcessCount: updatePayload?.FldProcessCount || 0,
                    fldPrintAccessCost: updatePayload?.fldPrintAccessCost,
                    fldOAPercentage: updatePayload?.fldOAPercentage
                }
            };
        case DELETE_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case DELETE_COPY_STYLE_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_STYLE_MASTER_FAILURE:
        case FETCH_STYLE_MASTER_DELETE_BY_ID_FAILURE:
        case FETCH_COPY_STYLE_MASTER_FAILURE:
        case COPY_STYLE_MASTER_ASSIGN_COLOR_FAILURE:
        case FETCH_MULTI_COPY_STYLE_MASTER_FAILURE:
        case FETCH_MULTI_COPY_STYLE_COLOR_MASTER_FAILURE:
        case CREATE_STYLE_MASTER_FAILURE:
        case CREATE_COPY_STYLE_MASTER_PART_FAILURE:
        case UPDATE_STYLE_MASTER_FAILURE:
        case UPDATE_COPY_STYLE_MASTER_FAILURE:
        case FETCH_SINGLE_STYLE_MASTER_FAILURE:
        case DELETE_STYLE_MASTER_FAILURE:
        case DELETE_COPY_STYLE_MASTER_FAILURE:
        case FETCH_STYLE_MASTER_BY_ID_FAILURE:
        case FETCH_STYLE_MASTER_CHECK_DEFAULT_VALUE_FAILURE:
        case CHECK_STITCHING_MEASUREMENT_BY_STYLE_FAILURE:
        case CREATE_STITCHING_MEASUREMENT_BY_STYLE_FAILURE:
        case STYLE_MASTER_UPDATE_APPROVALSTATUS_FAILURE:
        case SEND_VERIFY_OTP_USERFORM_FAILURE:
        case FETCH_COSTING_ACTIVE_ONLY_FAILURE:

            return {
                ...state,
                loading: false,
                showErrorAlert: true,
                errorMessage: updatePayload
            };
        case CREATE_COPY_STYLE_MASTER_NEW_OPTION_FAILURE:
            return {
                ...state,
                loading: false,
                copyStyleLoading: false,
                showErrorAlert: true,
                errorMessage: updatePayload
            };
        case CREATE_COPY_STYLE_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                copyStyleLoading: false,
                showErrorAlert: true,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STYLE_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_COPY_STYLE_MASTER:
            return {
                ...state,
                loading: false,
                copyStyleForm: {
                    ...state.copyStyleForm,
                    [payload.key]: payload.value
                }
            };
        case RESET_DIA_RESPONSE:
            return {
                ...state,
                diaResponseStatus: ''
            };
        case STYLE_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                isDefaultValue: false,
                copyStyleMasterList: {},
                copyStyleMasterListAfterAdd: {},
                deleteStyleMasterById: []
            };
        case COPY_STYLE_MASTER_USERFORM_RESET:
            return {
                ...state,
                copyStyleForm: {
                    InwardNO: [],
                    fldFKColour: [],
                    fldColour: [],
                    idCopyMainStyle: true,
                    isCopyAll: false,
                    isBuyerCheck: false
                },
                copyStyleMasterList: {},
                copyStyleMasterListAfterAdd: {},
                multiCopyColorList: [],
                copyStyleColorList: []
            };
        case COPY_STYLE_MASTER_USERFORM_RESET2:
            return {
                ...state,
                copyStyleForm: {
                    InwardNO: [],
                    fldFKColour: [],
                    fldColour: [],
                    idCopyMainStyle: state.copyStyleForm.idCopyMainStyle,
                    isCopyAll: false,
                    isBuyerCheck: false
                },
                copyStyleMasterList: {},
                copyStyleMasterListAfterAdd: {},
                multiCopyColorList: [],
                copyStyleColorList: []
            };
        case STYLE_MASTER_USERFORM_DROPDOWNLIST_RESET:
            return {
                ...state,
                userform: { ...state.userform, BuyName: '' }
            };

        case NAVIGATE_STYLE_DETAILS: {
            return {
                ...state,
                isStyleMaster: 'styleMasterDetails',
                isStylePreparation: false,
                styleMasterId: payload?.styleMasterId
            };
        }
        case NAVIGATE_SIZE_MEASUREMENTS_DETAILS: {
            return {
                ...state,
                isStyleMaster: 'styleDetailSizeMeasure',
                isStylePreparation: false,
                styleMasterId: payload?.styleMasterId

            }
        }
        case NAVIGATE_STYLE_MASTER: {
            return {
                ...state,
                isStyleMaster: 'styleMaster',
                styleMasterMainId: payload?.styleMasterId,
                isStylePreparation: false
            };
        }
        case NAVIGATE_STYLE_MASTER_MAIN: {
            return {
                ...state,
                isStyleMaster: 'styleMasterMain',
                isStylePreparation: false
            };
        }
        case NAVIGATE_STYLE_PREPARATION: {
            return {
                ...state,
                stylePreparationFlag: flag,
                isStylePreparation: true,
                styleMasterId: payload?.styleMasterId
            };
        }
        case SET_RADIO_BUTTON_DATA_COPY_STYLE:
            {
                return {
                    ...state,
                    renderGridBtn: payload
                };
            }
        default:
            return state;
    }
};
